import { render, staticRenderFns } from "./AppUserandAccess.vue?vue&type=template&id=e9d5faa4&"
import script from "./AppUserandAccess.vue?vue&type=script&lang=js&"
export * from "./AppUserandAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports